import React from 'react';
import { FC } from 'react';
import Switch, { ReactSwitchProps } from 'react-switch';
import styled from 'styled-components';
import { lighten } from 'polished';
import theme from '../theme/theme';

export type ZSwitchVariant = 'default' | 'ai';

interface ZSwitchProps extends ReactSwitchProps {
    variant?: ZSwitchVariant;
    className?: string;
}

const SwitchWrapper = styled.div<{ checked?: boolean; $variant: ZSwitchVariant }>`
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 2px;
    border-radius: 50px;

    .react-switch {
        pointer-events: auto;
    }

    .react-switch-bg {
        transition: background 0.3s ease;
        background: ${({ checked, $variant }) => {
            if (!checked) return '#888';
            if ($variant === 'ai') return 'linear-gradient(90deg, rgba(59, 130, 246, 0.7) 3.75%, rgba(139, 92, 246, 0.7) 103.75%)';
            return lighten(0.2, theme.app.secondary);
        }} !important;
    }

    .react-switch-handle {
        transition: all 0.3s ease;
        background: ${({ checked, $variant }) => {
            if (!checked) return '#fff';
            if ($variant === 'ai') return 'linear-gradient(90deg, #3B82F6 3.75%, #8B5CF6 103.75%)';
            return theme.app.secondary;
        }} !important;
        border: ${({ checked }) => (checked ? 'none' : `1px solid #888`)};
        position: relative;
        z-index: 1;
    }
`;

export const ZSwitch: FC<ZSwitchProps> = ({ variant = 'default', checked, className, ...props }) => {
    return (
        <SwitchWrapper checked={checked} $variant={variant} className={className}>
            <Switch
                checked={checked}
                onColor='#fff'
                offColor='#fff'
                onHandleColor='#fff'
                offHandleColor='#fff'
                handleDiameter={20}
                uncheckedIcon={false}
                checkedIcon={false}
                boxShadow='0px 0px 2px 0px rgba(0,0,0,0.3)'
                activeBoxShadow='0px 0px 2px 0px rgba(0,0,0,0.3)'
                height={13}
                width={32}
                className='react-switch'
                {...props}
            />
        </SwitchWrapper>
    );
};
